import { AfterViewInit, Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { USER_MANUAL_CONFIG } from '@core/constants/api.constants';
import { AppService } from '@core/services/app/app-api';
import { SoftwareService } from '@core/services/download-center/software/software-api';
import { OrgAndStockroomService } from '@core/services/org-and-stockroom/org-and-stockroom-api';
import { ToastService } from '@core/services/toast-api';
import { TranslateService } from '@ngx-translate/core';
import saveAs from 'file-saver';
import { Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { SharedModule } from '@shared/shared.module';
import { FormsModule } from '@angular/forms';
import { MaterialsModule } from '@shared/materials.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-user-manual',
  templateUrl: './user-manual.html',
  styleUrls: ['./user-manual.scss'],
  standalone: true,
  imports: [CommonModule, SharedModule, FormsModule, MaterialsModule, TranslateModule],
})
export class UserManualComponent implements OnInit, AfterViewInit {
  @ViewChild('pdfViewerContainer', { read: ViewContainerRef })
  pdfViewerContainer!: ViewContainerRef;
  componentRef: any;
  isLoading: boolean = true;
  showSearchPanel: boolean = false;
  private destroy$: Subject<void> = new Subject();
  @ViewChild('PdfViewerComponent') pdfComponent!: any; // Use 'any' type for dynamic import
  searchText: string = "";
  pdfQuery = '';
  pdfPage = 22;
  loadPdfProgress: number = 0;

  constructor(
    private router: Router,
    private injector: Injector,
    private softwareService: SoftwareService,
    private toastService: ToastService,
    private translateService: TranslateService,
    public appService: AppService,
    public orgAndStockroomService: OrgAndStockroomService
  ) {
  }

  ngOnInit(): void {
    // Load ng2-pdf-viewer module dynamically
    this.orgAndStockroomService.manual$.subscribe((value) => {
      this.loadPdfViewerModule();
      // Do additional actions based on the flag value
    });
    this.router.events.subscribe((val) => {
      // see also 
      if (val instanceof NavigationEnd) {
        // Your code
        let page = val.url;
        this.gotoSection(page)

      }

    });

    this.appService.userManualPdfId.subscribe((id: any) => {
      this.userManual = id;
    })
  }

  gotoSection(page: any) {
    if (page == '/app') {
      this.pdfPage = 23;
      this.scrollToPage(this.pdfPage)
    } else if (page.includes('replenish-stock')) {
      this.pdfPage = 32;
      this.scrollToPage(this.pdfPage)

    } else if (page.includes('receive-stock')) {
      this.pdfPage = 47;
      this.scrollToPage(this.pdfPage)

    } else if (page.includes('create-barcodes')) {
      this.pdfPage = 60;
      this.scrollToPage(this.pdfPage)

    } else if (page.includes('stock-correction')) {
      this.pdfPage = 71;
      this.scrollToPage(this.pdfPage)

    } else if (page.includes('manage-stockroom')) {
      this.pdfPage = 75;
      this.scrollToPage(this.pdfPage)

    } else if (page.includes('vendor-maintenance')) {
      this.pdfPage = 99;
      this.scrollToPage(this.pdfPage)

    } else if (page.includes('product-maintenance')) {
      this.pdfPage = 105;
      this.scrollToPage(this.pdfPage)

    } else if (page.includes('user-maintenance')) {
      this.pdfPage = 126;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('consume-stock')) {
      this.pdfPage = 27;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('article-activity-log')) {
      this.pdfPage = 137;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('stockroom-activity-log')) {
      this.pdfPage = 138;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('reporting')) {
      this.pdfPage = 141;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('download-center')) {
      this.pdfPage = 149;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('cost-center-maintenance')) {
      this.pdfPage = 88;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('department-maintenance')) {
      this.pdfPage = 93;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('reference-codes')) {
      this.pdfPage = 79;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('export-import-stockroom')) {
      this.pdfPage = 77;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('approval')) {
      this.pdfPage = 56;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('help')) {
      this.pdfPage = 8;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('scanner-replenish')) {
      this.pdfPage = 45;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('stock-transfer')) {
      this.pdfPage = 124;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('reason-code-maintenance')) {
      this.pdfPage = 98;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('location-maintenance')) {
      this.pdfPage = 87;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('account-settings')) {
      this.pdfPage = 12;
      this.scrollToPage(this.pdfPage)
    }

    else if (page.includes('requests')) {
      this.pdfPage = 139;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('orders')) {
      this.pdfPage = 139;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('products')) {
      this.pdfPage = 140;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('track-orders')) {
      this.pdfPage = 140;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('return-stock')) {
      this.pdfPage = 59;
      this.scrollToPage(this.pdfPage)
    }
    else if (page.includes('communications')) {
      this.pdfPage = 16;
      this.scrollToPage(this.pdfPage)
    }
    else {
      this.pdfPage = 1;
      this.scrollToPage(this.pdfPage)
    }

  }

  ngAfterViewInit() {

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  @Input() openPanel: boolean = false;
  @Input() userManual: any;
  @Output() closePanel = new EventEmitter<void>();

  close() {
    this.closePanel.emit();
  }

  afterLoadComplete(pdf: any) { // Use 'any' type for dynamic import
    // Your logic after the PDF has been loaded completely
    setTimeout(() => {
      // this.scrollToPage(this.pdfPage);
      if (this.router.url) {
        let page = this.router.url;
        this.gotoSection(page);
      }
      // Now scroll to page 10
    }, 500);
  }

  private loadPdfViewerModule() {
    if (this.componentRef) {
      this.componentRef.instance.src = this.appService.pdfSrc;
      return;
    }

    import('ng2-pdf-viewer').then((module) => {
      // const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
      //   module.PdfViewerComponent
      // );

      this.componentRef = this.pdfViewerContainer.createComponent(
        module.PdfViewerComponent,
        {
          injector: this.injector
        }
      );

      this.componentRef.instance.src = this.appService.pdfSrc;
      this.componentRef.instance.renderText = true;
      this.componentRef.instance.originalSize = false;
      this.componentRef.instance.zoom = 1;

      if (this.componentRef && this.componentRef.instance) {

        // Your code to access properties or methods on this.componentRef.instance
        // Set up a progress callback
        const progressCallback = (progress: any) => {
          this.loadPdfProgress = Math.round((progress.loaded / progress.total) * 100);
        };

        // Update progress in the UI
        this.componentRef.instance.onProgress.pipe(takeUntil(this.destroy$)).subscribe(progressCallback);

      }


      // Hide loader when PDF is fully loaded
      this.componentRef.instance.afterLoadComplete.subscribe((event: any) => {
        this.afterLoadComplete(event);
        // Now that we have subscribed to progressData, set progress to 100
        this.loadPdfProgress = 100;
      });
    });
  }

  scrollToPage(pageNumber: number) {
    if (this.componentRef) {
      this.componentRef.instance.pdfViewer.scrollPageIntoView({
        pageNumber: Number(pageNumber),
      })
    }
  }

  searchQueryChanged(newQuery: string) {
    const type = newQuery !== this.pdfQuery ? '' : 'again';
    this.pdfQuery = newQuery;
  }

  downloadUserManual() {
    import('ng2-pdf-viewer').then((module) => {
      const softwareId = this.userManual;
      const fileName = this.translateService.instant('ime.usermanual.link.label');
      this.softwareService.downloadSoftware(softwareId).subscribe(
        res => {
          if (res && res.body) {
            saveAs(res.body, `${fileName}.${'pdf'}`);
            this.toastService.show(
              'success',
              this.translateService.instant('ime.download.succesful'),
              this.translateService.instant('ime.file.has.been.downloaded.succesfully'),
              false,
              3000
            );
          } else {
            this.toastService.show(
              'error',
              this.translateService.instant('ime.download.failed'),
              this.translateService.instant('invalid.file.delete.msg'),
              false,
              3000
            );
          }
        },
        error => {
          this.toastService.show(
            'error',
            this.translateService.instant('ime.download.failed'),
            this.translateService.instant('invalid.file.delete.msg'),
            false,
            3000
          );
        }
      );
    });
  }
}
